import {
  SET_CLIENT_DETAILS,
  SET_CLIENT_DETAILS_START,
  SET_CLIENT_DETAILS_FAILED,
  SET_SELECTED_CLIENT_DETAILS,
  SET_CLIENT_TAGS,
  SET_CLIENT_QUALITATIVE_SETTINGS,
  SET_JOURNALIST_ACCESS,
  SET_FEED_TAGS_FINISH,
  SET_FEED_TAGS_START,
  SET_FEED_TAGS_FAILED,
  SET_AUTH,
  SET_USER_PASSWORD_DETAILS,
  SET_CLIENT_SUB_USER,
  SET_CLIENT_MASTER,
  SET_CLIENT_MASTER_LIST,
  SET_CLIENT_LANGUAGE,
  SET_STATE,
  SET_CLIENT_SUB_USER_FILTER_DATA,
} from "./actionTypes";
import { envConfig, qualitativeEnvConfig, unifiedEnvConfig } from "../constants/api-endpoint";
import { COOKIE, TRACKING_ALLOWED_CLIENTS } from "../constants/app-constant";
import { getCookie } from "../utility/cookieProvider";
import { fetchEntityDetails } from "./entity-action";
import { httpGet, httpPost } from "../utility/requestHelper";

export const fetchClientDetails = (callAllApis) => {
  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);
  return (dispatch) => {
    dispatch(setClientStart());
    httpPost(`${envConfig.GET_CLIENTS}`, {
      user_id: concept_uid,
    })
      .then(async(res) => {
        const {
          data: { status, result, messsage },
        } = res || {};
        if (status === 200 && result) {
          dispatch(setClient(result));
          const selClient = result[0];
          if (selClient) {
            const { id, client_name } = selClient;
            if(TRACKING_ALLOWED_CLIENTS.includes(id.toString())){
              dispatch(getClientMasterUserData(id,concept_uid));
              dispatch(getClientSubUserData({client_id:id}));
              setTimeout(() => {
                dispatch(getClientLanguages(id));
                dispatch(getState())
              }, 500);
            }
            dispatch(setSelectedClient(selClient));
            let passwordData = await fetchUserPasswordDetails(concept_uid);
            dispatch(setUserPasswordData(passwordData.data));
            if (callAllApis) {
              dispatch(fetchEntityDetails(id, client_name));
              dispatch(fetchClientTagData(id));
              dispatch(fetchJournalistAccessData(concept_uid));
              dispatch(fetchTagsList(id));
              //dispatch(fetchQualitativeSettings(id));
            }
          }
        } else {
          dispatch(setClientFailed(messsage));
        }
      })
      .catch((e) => {
        dispatch(setClientFailed(e));
      });
  };
};

export const fetchCustomClientDetails = (id,client_name) => {
  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);
  
  return (dispatch) => {
    if(TRACKING_ALLOWED_CLIENTS.includes(id.toString())){
      dispatch(getClientMasterUserData(id,concept_uid));
      dispatch(getClientSubUserData({client_id:id}));
      dispatch(getClientLanguages(id));
      dispatch(getState())
    }
    dispatch(fetchEntityDetails(id, client_name));
    dispatch(fetchClientTagData(id));
    dispatch(fetchJournalistAccessData(concept_uid));
    dispatch(fetchTagsList(id));
  };
};

export const fetchUserPasswordDetails = async (userId) => {
  // return async (dispatch) => {
  return await httpPost(`${unifiedEnvConfig.GET_USER_PASSWORD_DETAILS}`, {
    user_id: userId,
  })
      // .then((res) => {
      //   const {
      //     data: { status, data },
      //   } = res || {};
      //   if (!status) {
      //     console.log(data)
      //     dispatch(setUserPasswordData(data)); 
      //   }
      // })
      // .catch((e) => {
      //   // console.log("")
      // });
  // };
};

export const isAuthenticated = () => {
  return (dispatch) => {
    httpGet(envConfig.ISAUTH, { "Access-Control-Allow-Origin": "*" }).then((res) => {
      dispatch(setAuth(res.data));
    });
  };
};

export const fetchClientTagData = (client_id) => {
  return (dispatch) => {
    httpPost(envConfig.ARTICLE_TAG_LIST, {
      client_id,
    }).then((response) => {
      const { data: { result = {} } = {} } = response || {};
      dispatch(setClientTaggingData(result));
    });
  };
};

export const fetchJournalistAccessData = (user_id) => {
  return (dispatch) => {
    httpPost(envConfig.SERVICE_ACCESS, {
      user_id,
    }).then((response) => {
      const {
        data: { status },
      } = response || {};
      dispatch(setJournalistAccess(status == 200));
    });
  };
};

export const setClient = (payload) => ({
  type: SET_CLIENT_DETAILS,
  payload,
});

export const setSelectedClient = (payload) => {
  return {
    type: SET_SELECTED_CLIENT_DETAILS,
    payload,
  };
};

export const setUserPasswordData = (payload) => {
  return {
    type: SET_USER_PASSWORD_DETAILS,
    payload,
  };
};

export const setClientTaggingData = (data) => {
  return {
    type: SET_CLIENT_TAGS,
    payload: data,
  };
};

const setClientStart = () => ({
  type: SET_CLIENT_DETAILS_START,
});

const setClientFailed = (e) => ({
  type: SET_CLIENT_DETAILS_FAILED,
  payload: e,
});

const setAuth = (e) => ({
  type: SET_AUTH,
  payload: e,
});

const setJournalistAccess = (allow) => ({
  type: SET_JOURNALIST_ACCESS,
  payload: allow,
});

const setClientTagsStart = () => ({
  type: SET_FEED_TAGS_START,
});

const setClientQualitativeSettings = (payload) => ({
  type: SET_CLIENT_QUALITATIVE_SETTINGS,
  payload,
})

const setClientTags = (tags) => ({
  type: SET_FEED_TAGS_FINISH,
  payload: tags,
});

const setClientTagsFailed = (error) => ({
  type: SET_FEED_TAGS_FAILED,
  payload: error,
});
export const setClientMaster = (payload) => ({
  type: SET_CLIENT_MASTER,
  payload: payload,
});
export const setClientMasterList = (payload) => ({
  type: SET_CLIENT_MASTER_LIST,
  payload: payload,
});
export const setClientSubUser = (payload) => ({
  type: SET_CLIENT_SUB_USER,
  payload: payload,
});
export const setClientSubUserFilterData = (payload) => ({
  type: SET_CLIENT_SUB_USER_FILTER_DATA,
  payload: payload,
});

export const setState = (payload) => ({
  type: SET_STATE,
  payload: payload,
});

export const setClientLanguage = (payload) => ({
  type: SET_CLIENT_LANGUAGE,
  payload: payload,
});

export const fetchTagsList = (clientId) => {
  return (dispatch) => {
    const perPage = 99999;
    const page = 0;
    dispatch(setClientTagsStart());
    httpGet(`${unifiedEnvConfig.GET_TAGS_LIST.replace(
      "{client_id}",
      clientId
    )}&perPage=${perPage}&page=${page}
  `)
      .then((res) => {
        const { status, data } = res.data;
        if (status === 200) {
          dispatch(setClientTags(data));
        }
      })
      .catch((err) => dispatch(setClientTagsFailed(err)));
  };
};

export const fetchQualitativeSettings = (clientId) => {
  return (dispatch) => {
    httpGet(`${qualitativeEnvConfig.qualitativeSettings}/${clientId}`)
      .then((res) => {
        const { data } = res;
        dispatch(setClientQualitativeSettings(data));
      })
      .catch((err) => {
        console.log(err);
      });
  }
}
export const getClientMasterUserData = (client_id,user_id) => {
  return (dispatch) =>
    httpPost(`${unifiedEnvConfig.GET_CLIENT_MASTER_USER}`,{client_id:client_id,user_id : user_id}).then((res) => {
      if (res && res.data.data.length) {
        dispatch(setClientMaster(res.data.data[0]));
        dispatch(getClientMasterUserList({
          client_id : client_id,
          join_name : true
        }))
      }
      else{
        dispatch(setClientMaster({}));
      }
    });
};
export const getClientMasterUserList = (tObj) => {
  try{
    return (dispatch) => {
      httpPost(`${unifiedEnvConfig.GET_CLIENT_MASTER_USER}`,tObj).then((res) => {
        if (res && res.data.data.length) {
          dispatch(setClientMasterList(res.data.data));
        }
        else{
          dispatch(setClientMasterList([]));
        }
      });
    }
  }
  catch(err){
    console.log(err)
  }
};
export const getClientSubUserData = (tObj) => {
  return (dispatch) =>
    httpPost(`${unifiedEnvConfig.GET_CLIENT_SUB_USER}`,tObj).then((res) => {
      if(tObj.isFilter){
        dispatch(setClientSubUserFilterData(res.data.data));
      }
      else{
        dispatch(setClientSubUser(res.data.data));
      }
    });
};

export const getClientLanguages = (client_id) => {
  console.log("into function")
  return (dispatch) =>
    httpPost(`${envConfig.CLIENT_LANGUAGE}`,{client_id:client_id}).then((res) => {
      dispatch(setClientLanguage(res.data.result));
  })
}

export const getState = () => {
  return (dispatch) =>
    httpPost(`${envConfig.GET_STATE}`,{}).then((res) => {
      dispatch(setState(res.data.result));
    });
};